import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from "@angular/router";
import { NgForm, FormGroup } from "@angular/forms";
import { DataService} from "../services/data.service";
import { ToastsManager} from 'ng2-toastr/ng2-toastr';
import { EditDataService, Info} from "../services/edit-data.service";
import { Http, Response } from '@angular/http';
import data from "devextreme/bundles/dx.all";

@Component({
  selector: 'app-qr',
  templateUrl: './qr.component.html',
  styleUrls: ['./qr.component.scss']
})
export class QrComponent implements OnInit {

  progress: boolean;
  public data: any = [];
  search: string;
  IDcontract: number;
  CScontract;
  error: boolean = false;
  errorCode: string;
  errorMessage: string;

  constructor(public router: Router,
              public dataService: DataService,
              public editDataService: EditDataService,
              public toastr: ToastsManager,
              public vRef: ViewContainerRef
             ) {
    this.toastr.setRootViewContainerRef(vRef);

    localStorage.removeItem('data');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('idd');

    this.progress = false;
    try {
      this.search = (new URL(window.location.href)).search;
      this.IDcontract = parseInt((/login=(\d+)/.exec(this.search))[1]);
      this.CScontract = (/passw=(\d+)/.exec(this.search))[1];
    } catch (err) {
      this.IDcontract = null;
      this.CScontract = null;
    }
  }

  ngOnInit() {
    if (this.IDcontract && this.CScontract) {
      this.verificate(this.IDcontract, this.CScontract);
    } else {
      this.error = true;
      this.errorCode = "";
      this.errorMessage = "Невiрна ссилка";
    }
  }

  verificate(IDcontract: number, CScontract) {
    this.dataService.getQRByIddCsd(IDcontract, CScontract)
      .subscribe(
        data => {
          this.progress = false;
          this.dataService.setData(data);
          this.router.navigate(['/order']);
        },
        error => {
          this.progress = false;
          error = JSON.parse(error._body);
          this.error = true;
          this.errorCode = error.status_code;
          this.errorMessage = error.message;
        }
      );
  };

}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/qr/qr.component.ts